import React from 'react'
import { object } from 'prop-types'
import Config from '../../../../config'
import ReduxStores from '../../../../stores/connects'
import classNames from 'classnames'

class SmsForm extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      userNumber: this.getUserContactNumber(),
      callBackMsg:'',
      formVisible: true,
      errMsg: false,
      disabled: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.updateValue = this.updateValue.bind(this)
    this.branchSmsCallback = this.branchSmsCallback.bind(this)
    this.handleSendAnother = this.handleSendAnother.bind(this)

  }

  branchSmsCallback(err, result){
    let newState = this.state
    newState['formVisible'] = false
    newState['errMsg'] = false

    if (err) {
      newState['callBackMsg'] = 'Sorry, something went wrong.'
      newState['errMsg'] = true
    } else {
      newState['callBackMsg'] = 'SMS sent!'
    }
    this.setState(newState)
  }

   getUserContactNumber() {
    const { loggedInData = {} } = this.props
    const loggedInStatus = loggedInData.hasOwnProperty('email')
    if (!loggedInStatus && !loggedInData.contact_number) return '+44'
    let phoneNumber = loggedInData.contact_number
    if (phoneNumber.substring(0, 2) !== '07' && phoneNumber.substring(0, 4) !== '+447' ) return '+44'
    const mobileNumber = (phoneNumber.substring(0, 2) === '07') ? '+44'+phoneNumber.slice(1) : phoneNumber
    return mobileNumber
  }

  updateValue (e) {
    this.setState({
      userNumber: e.target.value
    })
  }

  handleSendAnother (e){
    e.preventDefault()
    this.setState({
      formVisible: true,
      disabled: false,
      userNumber: '+44'
    })
  }

   handleSubmit (e) {
    e.preventDefault()
    this.setState({ disabled: true })
    const { agentData, pageData } = this.props
    const appSettings = Config.appSettings
    const { userNumber } = this.state
    const options = {}
    const campaign = pageData.pageName === 'holiday-extras-mobile-app-cc' ? 'care-cc-agent' : appSettings.campaign

    if (!userNumber || typeof branch === 'undefined') return
    branch.init(appSettings.branch_key)
    const linkData = {
      tags: [],
      campaign: campaign,
      channel: appSettings.channel,
      feature: appSettings.feature,
      data: {
          'agentCode': agentData.agent,
          'launchId':'',
          '$custom_sms_text': 'Download the Holiday Extras APP {{ link }}'
      }
    }
    branch.sendSMS(userNumber, linkData, options, this.branchSmsCallback)
  }


  render () {
    const { id, agentData } = this.props
    const { userNumber, formVisible, callBackMsg, errMsg, disabled } = this.state
    const resultClassNames = classNames('smsMsg', {
      'error': errMsg
    })

    return (
      <div id={id}>
        {formVisible && (
          <div>
            <h3>We'll send a link via SMS to your mobile</h3>
            <form id='SmsForm' onSubmit={this.handleSubmit} method='get'>
              <div className='form-group'>
                <input id='phone' name='phone' type='tel' placeholder='+44' className='form-control' pattern='^\+[1-9]{1}[0-9][0-9-]*$' onChange={this.updateValue} value={userNumber} required />
                <span className='validity' />
              </div>
              <button className='btn btn-primary hx-btn-ultimate sms-btn' type='submit' data-hxtrack-name='sms_link' disabled={disabled}>
                {disabled && <span className='btn-text'>Sending...</span>}
                {!disabled && <span className='btn-text'>Send link to my phone</span>}
              </button>
              <input type='hidden' name='agent' defaultValue={agentData.agent} />
            </form>
          </div>
        )}
        {!formVisible &&
        <div className="smsResp">
          <h4 className={resultClassNames}>{callBackMsg}</h4>
          <p className='sendAnother'><a onClick={this.handleSendAnother} title='send another sms' className='sendAnother'>Send another SMS</a></p>
        </div>
        }
      </div>
    )
  }
}

SmsForm.propTypes = {
  agentData: object
}

//export default SmsForm

export default ReduxStores(SmsForm, ['login'], true)



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/content/sendSMSForm.jsx